import { SvgCrossIcon } from '@ui-kit'
import { ShortcutKeys, TAB_INDEX_DEFAULT } from '../../constants/form.constants'
import { AppliedFilterType } from '@app-store'
import { DASHBOARD } from '../../utils/constants'

const AppliedFilters = ({
  selectedFilters,
  handleClearChip,
  handleClearAll,
}: AppliedFilterType) => {
  return (
    <div className="flex min-h-0 rounded w-full justify-between items-center">
      <div className=" w-full h-full px-2.5 py-3">
        <div className="flex flex-wrap gap-2.5 items-center">
          <span className="text-base font-semibold">Applied Filter: </span>
          {selectedFilters?.map((filter, index) => {
            return filter?.value?.length > 0 ? (
              <div
                key={`${filter.value}_${index}`}
                className="bg-secondary-50 text-accent-500 flex justify-center items-center py-1 px-2 rounded-full gap-2"
                data-qa-id={`selected-permission-${filter.value}`}
              >
                <span className="text-base font-primary text-accent-600">
                  {filter.value}
                </span>
                <span
                  className="p-[0.0625rem] cursor-pointer"
                  data-qa-id={'clear-permission-set-chip'}
                  onClick={(e) => {
                    handleClearChip(filter)
                    e.stopPropagation()
                  }}
                  tabIndex={TAB_INDEX_DEFAULT}
                  onKeyDown={(e) => {
                    if (
                      e?.key === ShortcutKeys.Enter ||
                      e?.key === ShortcutKeys.Space
                    ) {
                      handleClearChip(filter)
                      e.stopPropagation()
                      e?.preventDefault()
                    }
                  }}
                >
                  <SvgCrossIcon
                    width={'12'}
                    height={'12'}
                    className="svg-path-fill-accent-500"
                  />
                </span>
              </div>
            ) : null
          })}
        </div>
      </div>
      <div className="flex w-[6%] items-center justify-center">
        <span
          className="cursor-pointer text-base text-primary-500 font-semibold"
          data-qa-id="dashboard-filter-clear-button"
          onClick={handleClearAll}
        >
          {DASHBOARD.CLEAR_ALL}
        </span>
      </div>
    </div>
  )
}

export default AppliedFilters
